class TagsFilter extends HTMLElement {
    constructor() {
      super();
      this.tagButtons = null;
      this.allTopicsButton = null;
    }
  
    connectedCallback() {
      this.initialize();
    }
  
    initialize() {
      this.tagButtons = this.querySelectorAll("[data-blog-tag]");
      this.allTopicsButton = this.querySelector("[data-blog-tag='all']");
  
      this.setupEventListeners();
      this.setInitialActiveState();
    }
  
    setupEventListeners() {
      this.tagButtons.forEach((button) => {
        button.addEventListener("click", () => this.handleTagClick(button));
      });
    }
  
    handleTagClick(button) {
      const selectedTag = button.getAttribute("data-blog-tag");
      const baseURL = this.getBaseURL();
  
      if (selectedTag === "all") {
        this.updateURL(baseURL);
      } else {
        this.updateURL(`${baseURL}/tagged/${selectedTag}`);
      }
    }
  
    getBaseURL() {
      const currentPath = window.location.pathname;
      const basePath = currentPath.split('/tagged')[0];
      return window.location.origin + basePath;
    }
    
    updateURL(newPath) {
      window.location.href = newPath;
    }
  
    setInitialActiveState() {
      const path = window.location.pathname;
      const currentTag = path.includes("/tagged/") ? path.split("/tagged/")[1] : null;
  
      if (currentTag) {
        this.tagButtons.forEach((button) => {
          if (button.getAttribute("data-blog-tag") === currentTag) {
            button.classList.add("tag-active");
          }
        });
      } else {
        this.allTopicsButton.classList.add("tag-active");
      }
    }
}
  
window.customElements.define("tags-filter", TagsFilter);

class BlogPagination extends HTMLElement {
  constructor() {
    super();
    this.currentPage = 1;
    this.itemsPerPage = parseInt(this.dataset.itemsPerPage) || 6;
    this.articles = [];
    this.totalPages = 1;
  }

  connectedCallback() {
    this.articles = Array.from(this.querySelectorAll('[data-article]'));
    this.totalPages = Math.ceil(this.articles.length / this.itemsPerPage);

    if (this.articles.length > this.itemsPerPage) {
      this.render();
      this.showPage(1);
    }
  }

  render() {
    const controls = this.querySelector('.pagination-controls');
    if (!controls || this.totalPages <= 1) return;

    controls.innerHTML = `
      <div class="flex items-center justify-center gap-2">
        <button class="pagination-prev" aria-label="Previous page" ${this.currentPage === 1 ? 'disabled' : ''}>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g class="pagination-arrow">
              <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#926850"/>
              <path d="M18.916 20.312L14.996 16.632L18.916 12.936H17.204L13.3 16.632L17.204 20.312H18.916Z" fill="#926850"/>
            </g>
          </svg>
        </button>
        <div class="pagination-numbers flex items-center gap-2"></div>
        <button class="pagination-next" aria-label="Next page" ${this.currentPage === this.totalPages ? 'disabled' : ''}>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g class="pagination-arrow">
              <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#926850"/>
              <path d="M13.084 20.312L17.004 16.632L13.084 12.936H14.796L18.7 16.632L14.796 20.312H13.084Z" fill="#926850"/>
            </g>
          </svg>
        </button>
      </div>
    `;

    this.renderNumbers();
    this.bindEvents();
  }

  renderNumbers() {
    const container = this.querySelector('.pagination-numbers');
    if (!container) return;

    const range = this.getPageRange();

    container.innerHTML = range.map(page => {
      if (page === '...') {
        return `<span class="text-[16px] opacity-50 px-1">...</span>`;
      }
      const isActive = page === this.currentPage;
      return `<button data-page="${page}" class="pagination-number px-1 ${isActive ? 'text-[24px]' : 'text-[16px] opacity-50'}">${page}</button>`;
    }).join('');
  }

  getPageRange() {
    if (this.totalPages <= 5) {
      return Array.from({ length: this.totalPages }, (_, i) => i + 1);
    }
    if (this.currentPage <= 3) {
      return [1, 2, 3, '...', this.totalPages];
    }
    if (this.currentPage >= this.totalPages - 2) {
      return [1, '...', this.totalPages - 2, this.totalPages - 1, this.totalPages];
    }
    return [1, '...', this.currentPage - 1, this.currentPage, this.currentPage + 1, '...', this.totalPages];
  }

  showPage(page) {
    this.currentPage = page;
    const start = (page - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;

    this.articles.forEach((article, index) => {
      article.style.display = (index >= start && index < end) ? '' : 'none';
    });

    this.updateButtons();
    this.renderNumbers();
  }

  updateButtons() {
    const prevBtn = this.querySelector('.pagination-prev');
    const nextBtn = this.querySelector('.pagination-next');

    if (prevBtn) {
      prevBtn.disabled = this.currentPage === 1;
      prevBtn.classList.toggle('opacity-50', this.currentPage === 1);
      prevBtn.classList.toggle('cursor-not-allowed', this.currentPage === 1);
    }

    if (nextBtn) {
      nextBtn.disabled = this.currentPage === this.totalPages;
      nextBtn.classList.toggle('opacity-50', this.currentPage === this.totalPages);
      nextBtn.classList.toggle('cursor-not-allowed', this.currentPage === this.totalPages);
    }
  }

  bindEvents() {
    this.querySelector('.pagination-prev')?.addEventListener('click', () => {
      if (this.currentPage > 1) this.showPage(this.currentPage - 1);
    });

    this.querySelector('.pagination-next')?.addEventListener('click', () => {
      if (this.currentPage < this.totalPages) this.showPage(this.currentPage + 1);
    });

    this.addEventListener('click', (e) => {
      if (e.target.matches('.pagination-number')) {
        this.showPage(parseInt(e.target.dataset.page));
      }
    });
  }
}

customElements.define('blog-pagination', BlogPagination);
